import { MetaFunction, redirect } from "@remix-run/cloudflare";
import { ActionFunctionArgs, LoaderFunctionArgs } from "@remix-run/node";
import BookingPage from "~/components/booking/BookingPage";
import { fallbackLng, supportedLngs } from "~/i18n";
import { handleLogin } from "~/lib/auth";
import { createSitemapFunction } from "~/lib/sitemap-generator";
import { getMenuHref, getMetaData } from "~/lib/utils";

export const sitemap = createSitemapFunction("booking");

export const meta: MetaFunction<typeof loader> = ({ data }) => {
  return getMetaData(data);
};

export async function action(args: ActionFunctionArgs) {
  const requestClone = args.request.clone();
  const formData = await requestClone.formData();
  if (formData.get("action") === "login") {
    return await handleLogin(args);
  }
  return Response.json({ error: "Method Not Allowed" }, { status: 405 });
}

export async function loader({ request, params, context }: LoaderFunctionArgs) {
  const env = (context as any)?.cloudflare?.env as
    | Record<string, string>
    | undefined;
  const url = new URL(request.url);
  const rawLocale = params?.locale || url.pathname.split("/")[1] || fallbackLng;
  const locale = supportedLngs.includes(rawLocale) ? rawLocale : fallbackLng;

  const bookingDisabled =
    (env?.BOOKING_DISABLED ?? "").toString().toLowerCase() === "true";
  if (bookingDisabled) {
    return redirect(getMenuHref(locale, "/coming-soon"));
  }

  return {
    services: [],
  };
}

export default function Booking() {
  return <BookingPage />;
}
